import _debounce from "lodash/debounce";
import { useEffect, useMemo, useState } from "react";
import { Input } from "semantic-ui-react";

import type { ChangeEvent } from "react";
import type { InputOnChangeData } from "semantic-ui-react";

const DEBOUNCE_TIME = 500;

type DebouncedInputProps = {
  value: string | number | null;
  placeholder: string;
  isNumeric?: boolean;
  onChangeDebounced: (value: string) => void;
};

export const DebouncedInput = ({ value, placeholder, isNumeric = false, onChangeDebounced }: DebouncedInputProps) => {
  const filterValue = value?.toString() ?? "";
  const [inputValue, setInputValue] = useState(filterValue);

  const debouncedOnChange = useMemo(() => _debounce(onChangeDebounced, DEBOUNCE_TIME), []);

  useEffect(() => {
    setInputValue(filterValue);

    return () => debouncedOnChange.cancel();
  }, [filterValue, debouncedOnChange]);

  const handleChange = (_event: ChangeEvent<HTMLInputElement>, { value: updatedValue }: InputOnChangeData) => {
    setInputValue(updatedValue);
    debouncedOnChange(updatedValue);
  };

  return <Input fluid value={inputValue} type={isNumeric ? "number" : "text"} placeholder={placeholder} onChange={handleChange} />;
};
